import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderUno from '../../Metodos/Compartidos/HeaderUno.js';
import HeaderDos from '../../Metodos/Compartidos/HeaderDos.js';
import FormularioNuevoPaciente from './FormularioNuevoPaciente.js';

import useConfigAuth from '../../../Hooks/useConfigAuth.js';

import {
    buscoPacienteAction
} from '../../../actions/nuevoPacienteActions.js';

import {
    estadoCorrectoInitialAction
} from '../../../actions/resetStoreActions.js';

// css
import { Cuerpo } from '../../Css/StyledHeader.js';

import {
    ContenedorNuevoPaciente,
    EncabezadoNuevoPaciente,
    TituloNuevoPaciente,
    TextoNuevoPaciente,
    OpcionesNuevoPaciente,
    OpcionPaciente,
    OpcionTitulo,
    OpcionDescripcion,
    ContenedorBusquedaPaciente,
    FormBusquedaPaciente,
    GrupoCampo,
    LabelCampo,
    InputCampo,
    TextoErrorCampo,
    BotonPrincipal,
    BotonSecundario,
    ResultadoBusqueda,
    AccionesResultado
} from '../../Css/StyledNuevoPaciente.js';


const NuevoPaciente = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [config] = useConfigAuth();

    const correcto = useSelector(
        (state) => state.estado.correcto
    );

    const [opcion, setOpcion] = useState(null);

    const [email, setEmail] = useState('');

    const [errorEmail, setErrorEmail] = useState('');


    /*
    ========================================
    SELECCIONAR TIPO DE ALTA
    ========================================
    */

    const seleccionarOpcion = (nuevaOpcion) => {

        setOpcion(nuevaOpcion);

        setErrorEmail('');


        /*
        Al cambiar de camino limpiamos
        cualquier resultado de búsqueda anterior.
        */
        if (correcto !== null) {

            dispatch(
                estadoCorrectoInitialAction()
            );
        }
    };


    /*
    ========================================
    EMAIL
    ========================================
    */

    const cambiarEmail = (e) => {

        setEmail(e.target.value);


        if (errorEmail) {
            setErrorEmail('');
        }


        /*
        Si el usuario modifica el email,
        el resultado anterior deja de ser válido.
        */
        if (correcto !== null) {

            dispatch(
                estadoCorrectoInitialAction()
            );
        }
    };


    /*
    ========================================
    BUSCAR PACIENTE EXISTENTE
    ========================================
    */

    const buscarPaciente = async (e) => {

        e.preventDefault();


        const emailLimpio =
            email
                .trim()
                .toLowerCase();


        if (!emailLimpio) {

            setErrorEmail(
                'Ingresá el email del paciente.'
            );

            return;
        }


        setErrorEmail('');


        const informacion = {

            config,

            payload: {
                email: emailLimpio
            }
        };


        await dispatch(
            buscoPacienteAction(informacion)
        );
    };


    /*
    ========================================
    SOLICITAR VINCULACIÓN

    Todavía no conectamos esta acción porque
    vamos a revisar el flujo real de migración.
    ========================================
    */

    const solicitarPaciente = () => {

        console.log(
            'Solicitar paciente:',
            email.trim().toLowerCase()
        );
    };


    /*
    ========================================
    VOLVER AL LISTADO
    ========================================
    */

    const irAlListado = () => {

        navigate(
            '/escritorio/pacientes'
        );
    };


    return (

        <Cuerpo>

            <HeaderUno />


            <HeaderDos
                link="/escritorio/pacientes"
                componente="Nuevo Paciente"
                paciente={false}
            />


            <ContenedorNuevoPaciente>


                {/* ======================================
                    ENCABEZADO
                ======================================= */}

                <EncabezadoNuevoPaciente>

                    <TituloNuevoPaciente>
                        Agregar paciente
                    </TituloNuevoPaciente>


                    <TextoNuevoPaciente>
                        Elegí cómo querés incorporar al paciente.
                    </TextoNuevoPaciente>

                </EncabezadoNuevoPaciente>


                {/* ======================================
                    OPCIONES
                ======================================= */}

                <OpcionesNuevoPaciente>


                    <OpcionPaciente
                        type="button"
                        className={
                            opcion === 'nuevo'
                                ? 'activa'
                                : ''
                        }
                        onClick={() =>
                            seleccionarOpcion('nuevo')
                        }
                    >

                        <OpcionTitulo>
                            Crear paciente nuevo
                        </OpcionTitulo>


                        <OpcionDescripcion>
                            Para un paciente que todavía no
                            tenés registrado. Podrás gestionar
                            sus turnos, historia clínica y
                            demás información.
                        </OpcionDescripcion>

                    </OpcionPaciente>


                    <OpcionPaciente
                        type="button"
                        className={
                            opcion === 'existente'
                                ? 'activa'
                                : ''
                        }
                        onClick={() =>
                            seleccionarOpcion('existente')
                        }
                    >

                        <OpcionTitulo>
                            El paciente ya utiliza YÖGEN
                        </OpcionTitulo>


                        <OpcionDescripcion>
                            Si ya tiene una cuenta en YÖGEN,
                            buscá su cuenta por email para
                            solicitar su vinculación.
                        </OpcionDescripcion>

                    </OpcionPaciente>

                </OpcionesNuevoPaciente>


                {/* ======================================
                    NUEVO PACIENTE
                ======================================= */}

                {opcion === 'nuevo' && (

                    <FormularioNuevoPaciente
                        onCreado={() =>
                            navigate(
                                '/escritorio/pacientes'
                            )
                        }
                    />

                )}


                {/* ======================================
                    PACIENTE EXISTENTE
                ======================================= */}

                {opcion === 'existente' && (

                    <ContenedorBusquedaPaciente>


                        <FormBusquedaPaciente
                            onSubmit={buscarPaciente}
                        >

                            <GrupoCampo>

                                <LabelCampo
                                    htmlFor="emailPaciente"
                                >
                                    Email del paciente
                                </LabelCampo>


                                <InputCampo
                                    id="emailPaciente"
                                    type="email"
                                    value={email}
                                    aria-invalid={
                                        Boolean(errorEmail)
                                    }
                                    placeholder="ejemplo@email.com"
                                    onChange={cambiarEmail}
                                />


                                {errorEmail && (

                                    <TextoErrorCampo>
                                        {errorEmail}
                                    </TextoErrorCampo>

                                )}

                            </GrupoCampo>


                            <BotonPrincipal
                                type="submit"
                            >
                                Buscar paciente
                            </BotonPrincipal>

                        </FormBusquedaPaciente>


                        {/* ===============================
                            PACIENTE YÖGEN
                        ================================ */}

                        {correcto?.tipo ===
                            'plataforma' && (

                            <ResultadoBusqueda>

                                Encontramos una cuenta de
                                YÖGEN asociada a este email.


                                <AccionesResultado>

                                    <BotonPrincipal
                                        type="button"
                                        onClick={
                                            solicitarPaciente
                                        }
                                    >
                                        Solicitar vinculación
                                    </BotonPrincipal>

                                </AccionesResultado>

                            </ResultadoBusqueda>

                        )}


                        {/* ===============================
                            YA ES ADMINISTRATIVO
                        ================================ */}

                        {correcto?.tipo ===
                            'administrativo' && (

                            <ResultadoBusqueda>

                                Este paciente ya está
                                registrado en tu listado.


                                <AccionesResultado>

                                    <BotonSecundario
                                        type="button"
                                        onClick={
                                            irAlListado
                                        }
                                    >
                                        Ir a mis pacientes
                                    </BotonSecundario>

                                </AccionesResultado>

                            </ResultadoBusqueda>

                        )}


                        {/* ===============================
                            YA ES PACIENTE COMPLETO
                        ================================ */}

                        {correcto?.tipo ===
                            'completo' && (

                            <ResultadoBusqueda>

                                Este paciente ya pertenece
                                a tu cuenta de YÖGEN.


                                <AccionesResultado>

                                    <BotonSecundario
                                        type="button"
                                        onClick={
                                            irAlListado
                                        }
                                    >
                                        Ir a mis pacientes
                                    </BotonSecundario>

                                </AccionesResultado>

                            </ResultadoBusqueda>

                        )}

                    </ContenedorBusquedaPaciente>

                )}

            </ContenedorNuevoPaciente>

        </Cuerpo>
    );
};


export default NuevoPaciente;